// worker for client-side ajax requests


//   //TODO: modify this
//   // Function to collect and structure the tapping data and metadata
//   export async function collectTappingData(participantId, grooveId, takeNumber, rhythmArray, rating) {
//     const timestamp = new Date().toISOString();
//     const geoData = await getUserGeoData(); // Fetch user's geo-data
  
//     // Structure the collected data and metadata into a JSON object
//     const data = {
//       filename: `${participantId}_${grooveId}_t${takeNumber}_r${rating}_${timestamp}`, // Structured identifier
//       participantId,
//       grooveId,
//       takeNumber,
//       timestamp,
//       rhythmArray,
//       rating,
//       geoData
//     };
  
//     console.log('Collected Data:', data); // For debugging purposes
//     return data; // Return the structured JSON object
//   }

// let httpIp = `127.0.0.1`;
// let httpPort = `5002`;


// // TODO: modify this
//   async function sendDataToServer(array, stepId, participantId, rating) {
//     const user_data = await collectTappingData(participantId, stepId, takeNumber, array, rating);
//     const data_url = `http://${httpIp}:${httpPort}/send_data`; //comment out when deploying
//     // const data_url =`https://tapthegroove.com/send_data`; //comment out when testing locally
//     console.log("Sending request to:", data_url);

//     try {
//       const response = await fetch(data_url, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(user_data)
//       });

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }     

//       const responseData = await response.json();
//       console.log('Server response:', responseData);
//     } catch (error) {
//       console.error('Error sending data to server:', error);
//     }
//   }
  





self.addEventListener('message', function(event) {
    const data = event.data;

    if (data.cmd === 'sendArray') {
        sendArrayToServer(data.array, data.bpm, data.temperatureValue, data.hitTolerance, data.isHttpConnected, data.httpIp, data.portInput, data.samplingStrategy);
    }
});


function sendArrayToServer(array, bpm, temperatureValue, hitTolerance, isHttpConnected, samplingStrategy) {
    if (!isHttpConnected) return;

    // const data_url = `http://${httpIp}:${portInput}/send_array`;
    // const data_url = `http://127.0.0.1:5002/send_array`;
    const data_url = `https://2groove.live/send_array`
    console.log("Sending request to:", data_url);

    const payload = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            array: array,
            bpm: bpm,
            temp: temperatureValue,
            thresh: hitTolerance,
            samplingStrategy: samplingStrategy
        })
    };

    fetch(data_url, payload)
    .then(response => response.json())  // Process as JSON first
    // checking the success field of the response, and if it's true, you're converting the data field (base64 encoded string of the MIDI binary) 
    // back to a byte array, and then you're posting this byte array back to the main thread:
    .then(data => {
        if (data.success) {
            console.log("Processing tapped rhythms...");
            // const midiData = new Uint8Array(data.data);  // Convert base64 string to byte array
            const base64decoded = atob(data.data);
            const midiData = new Uint8Array(base64decoded.length).map((_, i) => base64decoded.charCodeAt(i));

            console.log("Received MIDI data length:", midiData.length);
            self.postMessage({type: 'arrayProcessed', data: midiData});
        } else {
            console.warn(data.message);
            self.postMessage({type: 'error', error: new Error(data.message)});
        }
    })    
    .catch(error => {
        console.error("Error:", error);
        self.postMessage({type: 'error', error: error});
    });
}




